import { render, staticRenderFns } from "./EducationalStandards.vue?vue&type=template&id=4749c89c&scoped=true&lang=pug&"
import script from "./EducationalStandards.vue?vue&type=script&lang=ts&"
export * from "./EducationalStandards.vue?vue&type=script&lang=ts&"
import style0 from "./EducationalStandards.vue?vue&type=style&index=0&id=4749c89c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749c89c",
  null
  
)

export default component.exports